// extracted by mini-css-extract-plugin
export default {"wrapper":"layout_wrapper__b47be","sideContent":"layout_sideContent__6ryFy","mainContent":"layout_mainContent__NZvTW"};